import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ContratingService } from '../../../services/modules/contrating.service';
import { VehicleService } from '../../../services/modules/vehicle.service';
import { environment } from 'src/environments/environment';
import { CommonOptions } from '../../../interfaces/interfaces';
import { CommonService } from '../../../services/modules/common.service';
import { SnackBarService } from '../../../services/utils/snackBar.service';
import { HttpErrorResponse } from '@angular/common/http';
import { UtilService } from 'src/app/core/services/utils/utils.service';
import { finalize } from 'rxjs/operators';

export interface DialogData {
  message: string;
  CompanyInfoParentId: any;
  vehicleContractId?: string;
  currentOwner?: {
    Name?: string;
    DocumentType?: string;
    DocumentNumber?: string;
    Logo?: string;
    PersonType?: string;
    ownerType?: string;
  };
}

export interface VehicleOwnerManager {
  CompanyInfoParentId: string;
  DocumentNumber: string;
  DocumentType: string;
  Logo: string;
  Name: string;
}

export interface OwnerVehicleResult {
  Id: string;
  Name: string;
  DocumentType: string;
  DocumentNumber: string;
  Logo: string;
  PersonType: string;
  ownerDocumentType: string;
  ownerDocumentNumber: string;
  ownerType: string;
  CompanyInfoId?: string;
}

@Component({
  selector: 'app-dialog-search-owner-vehicle',
  templateUrl: './dialog-search-owner-vehicle.component.html',
  styleUrls: ['./dialog-search-owner-vehicle.component.scss']
})
export class DialogSearchOwnerVehicleComponent implements OnInit {
  digito: string;
  s3Bucket: string;
  documentType: string;
  maxCaracter = 9;
  CompanyInfoParentId: any;
  vehicleContractId: string;
  documentNumber = '';
  flagValidNit = true;
  personType = 'JURIDICA';
  isPrefilling = false;
  isLoading = false;
  isSaving = false;

  vehicleSelected: any[] = [];
  vehicles: VehicleOwnerManager[] = [];
  allDocumentTypes: CommonOptions[] = [];
  companyDocumentType: CommonOptions[] = [];

  constructor(
    public dialogRef: MatDialogRef<DialogSearchOwnerVehicleComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private contratingService: ContratingService,
    private commonService: CommonService,
    private snackBService: SnackBarService,
    private utilService: UtilService,
    private vehicleService: VehicleService
  ) {
    this.CompanyInfoParentId = this.data.CompanyInfoParentId;
    this.vehicleContractId = this.data.vehicleContractId || '';
  }

  ngOnInit(): void {
    this.s3Bucket = environment.api.s3Bucket;
    setTimeout(() => {
      this.getServices();
      this.getManagedVehicles();
      this.loadCurrentOwnerData();
    }, 300);
  }

  private loadCurrentOwnerData(): void {
    const currentOwner = this.data.currentOwner;
    if (!currentOwner?.DocumentNumber) {
      return;
    }

    this.isPrefilling = true;

    if (currentOwner.ownerType === 'company') {
      this.personType = 'JURIDICA';
    } else if (currentOwner.ownerType === 'personal') {
      this.personType = 'NATURAL';
    } else {
      this.personType = currentOwner.DocumentType === 'NIT' ? 'JURIDICA' : 'NATURAL';
    }

    this.documentType = currentOwner.DocumentType || (this.personType === 'JURIDICA' ? 'NIT' : 'CC');

    const raw = (currentOwner.DocumentNumber || '').trim();

    if (this.documentType === 'NIT') {
      // Si viene con guion: 860503600-9
      if (raw.includes('-')) {
        const [base, dv] = raw.split('-');
        this.documentNumber = (base || '').trim();
        this.digito = (dv || '').trim().substring(0, 1);
      } else {
        this.documentNumber = raw.replace(/\D/g, '');
        const dvCalc = this.utilService.calcularDigito(this.documentNumber);
        this.digito = dvCalc !== null && dvCalc !== undefined ? String(dvCalc) : '';
      }
    } else {
      this.documentNumber = raw;
      this.digito = '';
    }

    this.setMaxCaracterByDocType(this.documentType);

    // (Opcional) si quieres pintar la card arriba cuando sí tengas Name:
    if (currentOwner.Name) {
      this.vehicleSelected = [{
        Name: currentOwner.Name,
        DocumentType: this.documentType,
        DocumentNumber: raw,
        Logo: currentOwner.Logo || ''
      }];
    }
    setTimeout(() => (this.isPrefilling = false), 0);
  }


  private setMaxCaracterByDocType(docType: string): void {
    switch (docType) {
      case 'NIT':
        this.maxCaracter = 9;
        break;
      case 'CC':
        this.maxCaracter = 11;
        break;
      case 'PE':
        this.maxCaracter = 15;
        break;
      default:
        this.maxCaracter = 11;
    }
  }

  etImgEmployer(logo, typeDocument): string {
    const defaultCompany = 'upload/images/form-images/file_235c080f-43b7-42c6-bd43-0af779cdb223.svg';
    const defaultPerson = 'assets/images/personblue.png';
    const isPersonDoc = typeDocument === 'CC' || typeDocument === 'CE' || typeDocument === 'PE';

    if (isPersonDoc) {
      return (logo === null || logo === '' || logo === undefined) ? defaultPerson : logo;
    }

    return (logo === null || logo === '' || logo === undefined) ? defaultCompany : logo;
  }

  setValuePersonal() {
    // Solo limpia la selección, NO los datos de búsqueda
    this.vehicleSelected = [];
    // Mantiene documentNumber, documentType y digito para permitir nueva búsqueda
  }

  changeMaxCaracter(e) {
    this.documentNumber = '';
    this.digito = '';
    this.setMaxCaracterByDocType(e.value);
  }

  onPersonTypeChange(e) {
    if (this.isPrefilling) {
      return;
    }

    this.vehicleSelected = [];
    this.documentNumber = '';
    this.digito = '';
    this.flagValidNit = true;

    this.personType = e.value;
    this.documentType = null;

    this.filterDocumentTypesByPersonType();     // define doc por defecto
    this.setMaxCaracterByDocType(this.documentType);
  }


  search() {
    // Validar NIT antes de buscar
    this.validateNit();

    // Validaciones según tipo de documento
    if (this.documentType === 'NIT') {
      if (this.documentNumber === '' || this.digito === undefined || !this.flagValidNit) {
        this.snackBService.openWarning('Compruebe los datos ingresados', undefined, 4000);
        return;
      }
    } else {
      if (this.documentNumber === '' || this.documentNumber.trim() === '') {
        this.snackBService.openWarning('Ingrese el número de documento', '', 4000);
        return;
      }
    }

    // Construir número final con dígito de verificación si es NIT
    let finalDocumentNumber = this.documentNumber.trim();
    if (this.documentType === 'NIT' && this.digito) {
      finalDocumentNumber = this.documentNumber.trim() + '-' + this.digito;
    }
    this.isLoading = true;

    // Ejecutar búsqueda según tipo de persona
    if (this.personType === 'JURIDICA') {
      this.searchEmployer(finalDocumentNumber);
    } else {
      this.searchPersonal(finalDocumentNumber);
    }
  }

  private searchEmployer(finalDocumentNumber: string) {
    const cleanDocumentNumber = this.documentNumber.trim();

    this.commonService.getSearchEmployerDocumentTypeName(this.documentType, cleanDocumentNumber).subscribe(
      (employer: any) => {
        this.vehicleSelected = [{
          Id: employer.Id,
          Name: employer.Name,
          DocumentType: this.documentType,
          DocumentNumber: finalDocumentNumber,
          Logo: employer.Logo || employer.FormImageLogo || '',
          Photo: '', // Empresas no tienen foto, solo logo
          CompanyInfoId: employer.CompanyInfoId || employer.Id
        }];
        this.isLoading = false;
      },
      (error: HttpErrorResponse) => {
        this.isLoading = false;

        // Manejar diferentes tipos de errores
        if (error.status === 404 || error.status === 424) {
          this.snackBService.openWarning(
            'Lo sentimos, no se encontró una empresa con este documento.',
            '',
            4000
          );
        } else if (error.status === 412) {
          this.snackBService.openWarning(
            'La empresa existe pero no está vinculada a su(s) proyecto(s).',
            '',
            4000
          );
        } else {
          this.snackBService.openWarning('Error al buscar empresa', '', 4000);
        }
      }
    );
  }

  private searchPersonal(finalDocumentNumber: string) {
    const cleanDocumentNumber = this.documentNumber.trim();

    if (this.documentType === 'PE') {
      this.searchPersonalWithFallback(cleanDocumentNumber, finalDocumentNumber);
    } else {
      this.executePersonalSearch(this.documentType, cleanDocumentNumber, finalDocumentNumber);
    }
  }

  private searchPersonalWithFallback(cleanDocumentNumber: string, finalDocumentNumber: string) {
    this.contratingService.getPersonalDocument('PE', cleanDocumentNumber).subscribe(
      (personal: any) => {
        this.handlePersonalSearchSuccess(personal, 'PE', finalDocumentNumber);
        this.isLoading = false;
      },
      (error: HttpErrorResponse) => {
        if (error.status === 404) {
          // Intentar con PEP si PE no funciona
          this.contratingService.getPersonalDocument('PEP', cleanDocumentNumber).subscribe(
            (personal: any) => {
              this.handlePersonalSearchSuccess(personal, 'PEP', finalDocumentNumber);
              this.isLoading = false;
            },
            (errorPEP: HttpErrorResponse) => {
              this.isLoading = false;
              if (errorPEP.status === 404) {
                this.snackBService.openWarning(
                  'Lo sentimos, no se encontró una persona con este documento.',
                  '',
                  4000
                );
              } else {
                this.snackBService.openWarning('Error al buscar persona', '', 4000);
              }
            }
          );
        } else {
          this.isLoading = false;
          this.snackBService.openWarning('Error al buscar persona', '', 4000);
        }
      }
    );
  }

  private executePersonalSearch(docType: string, cleanDocumentNumber: string, finalDocumentNumber: string) {
    this.contratingService.getPersonalDocument(docType, cleanDocumentNumber).subscribe(
      (personal: any) => {
        this.handlePersonalSearchSuccess(personal, docType, finalDocumentNumber);
        this.isLoading = false;
      },
      (error: HttpErrorResponse) => {
        this.isLoading = false;
        if (error.status === 404) {
          this.snackBService.openWarning(
            'Lo sentimos, no se encontró una persona con este documento.',
            '',
            4000
          );
        } else {
          this.snackBService.openWarning('Error al buscar persona', '', 4000);
        }
      }
    );
  }

  private handlePersonalSearchSuccess(personal: any, docType: string, finalDocumentNumber: string) {
    let fullName = personal.Name || '';
    if (personal.LastName) {
      fullName = `${personal.Name || ''} ${personal.LastName}`.trim();
    }

    let personalId = '';
    if (personal.PersonalId) {
      personalId = personal.PersonalId;
    } else if (personal.Id) {
      personalId = personal.Id;
    } else if (personal.PersonId) {
      personalId = personal.PersonId;
    }

    // Mostrar tarjeta de propietario seleccionado con todos los datos
    this.vehicleSelected = [{
      Id: personalId,
      Name: fullName,
      DocumentType: docType,
      DocumentNumber: finalDocumentNumber,
      Photo: personal.Photo || '',
      Logo: '',
      CompanyInfoId: personal.PersonalCompanyInfoId || personal.CompanyInfoId || personalId
    }];
  }

  validateNit(): void {
    if (this.documentType === 'NIT' && this.documentNumber !== '' && this.digito !== undefined) {
      this.flagValidNit = parseInt(this.digito, 10) === this.utilService.calcularDigito(this.documentNumber);
    }
  }

  /**
   * Válida sí se puede ejecutar la búsqueda
   */
  canSearch(): boolean {
    if (this.isLoading) {
      return false;
    }

    if (this.documentType === 'NIT') {
      return this.documentNumber !== '' && this.digito !== undefined && this.digito !== '' && this.flagValidNit;
    } else {
      return this.documentNumber !== '' && this.documentNumber.trim() !== '';
    }
  }

  /**
   * Guarda el propietario seleccionado directamente en el backend
   */
  saveOwner(): void {
    if (this.vehicleSelected.length === 0) {
      this.snackBService.openWarning('Debe seleccionar un propietario', '', 4000);
      return;
    }

    if (!this.vehicleContractId) {
      this.snackBService.openWarning('Error: No se puede guardar sin ID de contrato de vehículo', '', 4000);
      return;
    }

    const selectedOwner = this.vehicleSelected[0];
    const putContractModel: any = {
      ownerDocumentType: this.documentType,
      ownerDocumentNumber: selectedOwner.DocumentNumber,
      ownerType: this.personType === 'JURIDICA' ? 'company' : 'personal'
    };

    this.isSaving = true;
    this.vehicleService.putVehicleContract(this.vehicleContractId, putContractModel)
      .pipe(finalize(() => {
          this.isSaving = false; })).subscribe({
        next: () => {
          this.snackBService.openSuccess('Propietario actualizado correctamente', '', 4000);

          // Preparar el resultado para devolver al componente padre
          const result: OwnerVehicleResult = {
            Id: selectedOwner.Id || '',
            Name: selectedOwner.Name,
            DocumentType: this.documentType,
            DocumentNumber: selectedOwner.DocumentNumber,
            Logo: this.personType === 'JURIDICA' ? selectedOwner.Logo : selectedOwner.Photo || '',
            PersonType: this.personType,
            ownerDocumentType: this.documentType,
            ownerDocumentNumber: selectedOwner.DocumentNumber,
            ownerType: this.personType === 'JURIDICA' ? 'company' : 'personal',
            CompanyInfoId: selectedOwner.CompanyInfoId || selectedOwner.Id
          };
          this.dialogRef.close(result);
        },
        error: (error: HttpErrorResponse) => {
          this.snackBService.openWarning('Error al actualizar el propietario', '', 5000);
        }
      });
  }

  getServices() {
    this.commonService.getCommonOptions('CompanyDocumentType').subscribe(
      (data: CommonOptions[]) => {
        this.allDocumentTypes = data.sort((a, b) => a.OrderNum > b.OrderNum ? 1 : -1);
        this.filterDocumentTypesByPersonType();
      }
    );
  }

  private filterDocumentTypesByPersonType(): void {
    let allowedValues: string[];

    if (this.personType === 'JURIDICA') {
      allowedValues = ['NIT', 'CC'];
    } else {
      allowedValues = ['CC', 'PE'];
    }

    this.companyDocumentType = this.allDocumentTypes.filter(doc => allowedValues.includes(doc.Value))
      .filter((doc, index, self) => index === self.findIndex(d => d.Value === doc.Value));

    if (!this.documentType) {
      this.documentType = this.personType === 'JURIDICA' ? 'NIT' : 'CC';
    }
  }

  getManagedVehicles() {
    this.contratingService.getManagedEmployers().subscribe(
      (rest: any) => {
        this.vehicles = rest.sort((a, b) => {
          return (a.Name > b.Name) ? 1 : ((b.Name > a.Name) ? -1 : 0);
        });
      }
    );
  }
}
